const session_expired = {
    title: '세션 만료',
    subtitle: '세션이 만료되었거나, 끊겼어요. 다시 로그인해 주세요.',
    button: '다시 로그인하기',
};
export default Object.freeze(session_expired);
